<br><br><br><br>
<div class="page-title">
  <h1 class="title-text">Near Miss PDFs</h1>
  <p class="form-desc">
  </p>
</div>
<div class="sse-hub-container">
  <div class="search-container">
    <mat-form-field class="search-input">
      <mat-label>Search...</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="" #filterInput>
    </mat-form-field>
  </div>
  @if (loading) {
    <div class="loading-spinner">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  }
  @if (error) {
    <div class="error-message">
      <mat-icon color="warn">error</mat-icon>
      <span>{{ error }}</span>
    </div>
  }
  @if (!loading && !error) {
    <div>
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <!-- Date of Report Column -->
        <ng-container matColumnDef="dateOfReport">
          <th mat-header-cell *matHeaderCellDef>
            Date of Report
            <button class="custom-menu-button" [matMenuTriggerFor]="dateMenu">
              &#x22EE;
            </button>
            <mat-menu #dateMenu="matMenu" class="custom-menu">
              <button mat-menu-item (click)="sortData('dateOfReport', 'asc')">Sort Ascending</button>
              <button mat-menu-item (click)="sortData('dateOfReport', 'desc')">Sort Descending</button>
              <button mat-menu-item (click)="clearSort()">Clear Sorting</button>
            </mat-menu>
          </th>
          <td mat-cell *matCellDef="let element"> {{ element.dateOfReport | date:'MM/dd/yyyy' }} </td>
        </ng-container>
        <!-- Rate Column -->
        <ng-container matColumnDef="rate">
          <th mat-header-cell *matHeaderCellDef>
            Potential For Injury Rating
            <button class="custom-menu-button" [matMenuTriggerFor]="rateMenu">
              &#x22EE;
            </button>
            <mat-menu #rateMenu="matMenu" class="custom-menu">
              <button mat-menu-item (click)="sortData('rate', 'asc')">Sort Ascending</button>
              <button mat-menu-item (click)="sortData('rate', 'desc')">Sort Descending</button>
              <button mat-menu-item (click)="clearSort()">Clear Sorting</button>
            </mat-menu>
          </th>
          <td mat-cell *matCellDef="let element"> {{ element.rate | titlecase }} </td>
        </ng-container>
        <!-- PDF Download Column -->
        <ng-container matColumnDef="fileUrl">
          <th mat-header-cell *matHeaderCellDef> PDF Link </th>
          <td mat-cell *matCellDef="let element">
            <a [href]="element.fileUrl" target="_blank" class="download-link">Download PDF</a>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
      </table>
      <!-- No Data Available -->
      @if (dataSource.filteredData.length === 0) {
        <div class="no-data-message">
          <mat-icon color="primary">info</mat-icon>
          <span>No data available.</span>
        </div>
      }
    </div>
  }
</div>

